// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { GetShipTosApiParameter } from "@insite/client-framework/Services/CustomersService";
import { AddStoreListCustomerResult } from "@store/Framework/Store/Pages/StoreListsDetails/Handlers/addSelectedShipTos";
import StoreListsDetailsState from "@store/Framework/Store/Pages/StoreListsDetails/StoreListsDetailsState";
import { StoreListCustomerModel, StoreListCustomersCollectionModel } from "@store/Framework/Types/ApiModels";
import { GetStoreListCustomersApiParameter } from "@store/Services/StoreListService";
import { Draft } from "immer";

const initialState: StoreListsDetailsState = {
    storeListId: "",
    shipTosParameter: {
        page: 1,
        exclude: ["showAll"],
        sort: "customerSequence",
        filter: "",
        additionalExpands: ["loadAllShipTos"],
    },
    customersParameter: {
        page: 1,
        exclude: ["showAll"],
        storeListId: "",
    },
};

const actions = {
    "Pages/StoreListDetails/SetStoreListId": (
        draft: Draft<StoreListsDetailsState>,
        action: { storeListId: string },
    ) => {
        draft.storeListId = action.storeListId;
        draft.customersParameter.storeListId = action.storeListId;
    },
    "Pages/StoreListDetails/SetStoreListCustomerList": (
        draft: Draft<StoreListsDetailsState>,
        action: { storeListCustomerList: StoreListCustomerModel[] },
    ) => {
        draft.storeListCustomerList = action.storeListCustomerList;
    },
    "Pages/StoreListDetails/BeginAddCustomerListToStoreList": (draft: Draft<StoreListsDetailsState>) => {},
    "Pages/StoreListDetails/CompleteAddCustomerListToStoreList": (
        draft: Draft<StoreListsDetailsState>,
        action: { result: AddStoreListCustomerResult },
    ) => {},
    "Pages/StoreListDetails/UpdateShipTosParameter": (
        draft: Draft<StoreListsDetailsState>,
        action: { result: GetShipTosApiParameter },
    ) => {
        draft.shipTosParameter = { ...draft.shipTosParameter, ...action.result };
    },
    "Pages/StoreListDetails/UpdateCustomersParameter": (
        draft: Draft<StoreListsDetailsState>,
        action: { result: Partial<GetStoreListCustomersApiParameter> },
    ) => {
        draft.customersParameter = { ...draft.customersParameter, ...action.result };
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type StoreListsDetailsActions = Parameters<typeof reducer>[1];
export default reducer;
